import { render, staticRenderFns } from "./ColorScalesHeader.vue?vue&type=template&id=4e1891f1&scoped=true"
import script from "./ColorScalesHeader.vue?vue&type=script&lang=ts"
export * from "./ColorScalesHeader.vue?vue&type=script&lang=ts"
import style0 from "./ColorScalesHeader.vue?vue&type=style&index=0&id=4e1891f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1891f1",
  null
  
)

export default component.exports